import type { SiteAddress } from "@/shared/business/SiteAddress.ts";

export interface SiteAddressOut {
  raisonSociale: string;
  adr1: string;
  adr2: string | null;
  cp: string;
  ville: string;
  country: string;
  timeZone: string;
}

export function mapToSiteAddress(dto: SiteAddressOut): SiteAddress {
  return {
    administrativeName: dto.raisonSociale,
    addressLine1: dto.adr1,
    addressLine2: dto.adr2 ?? undefined,
    postalCode: dto.cp,
    city: dto.ville,
    country: dto.country,
    timeZone: dto.timeZone,
  };
}
